var mentions_default = {
  "mention": "Q8Ivx",
  "mentionViewer": "PxbOm",
  "cursorDefault": "akdAh",
  "cursorPointer": "n1aRP"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
